import React from "react";
import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import ProblemPromise from "@/components/ProblemPromise";
import Process from "@/components/Process";
import Counselling from "@/components/Counselling";
import Services from "@/components/Services";
import GetShortlist from "@/components/GetShortlist";
import Tracks from "@/components/Tracks";
import SpecialisedPathways from "@/components/SpecialisedPathways";
import Destinations from "@/components/Destinations";
import WhyMindways from "@/components/WhyMindways";
import Outcomes from "@/components/Outcomes";
import Testimonials from "@/components/Testimonials";
import Founder from "@/components/Founder";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import CookiePolicy from "@/pages/CookiePolicy";

function LandingPage() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <ProblemPromise />
        <Counselling />
        <Process />
        <Services />
        <GetShortlist />
        <Tracks />
        <SpecialisedPathways />
        <Destinations />
        <WhyMindways />
        <Outcomes />
        <Testimonials />
        <Founder />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
